import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME5,
				});
				navigate(ROUTES.START_GAME5, {
					state: { activeScenario: 1 },
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<StartGameFlowLayout
			stepKicker="Paso 4 · Reglas (3/3)"
			sidebarTitle="Reglas Dinámica III"
			loading={loading}
			onContinue={handleNext}
		>
			<div className="start-game-rule-block">
				<h3>Retroalimentación</h3>
				<p>
					Conseguirán retroalimentación en los momentos clave del caso.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>El equipo con mayor puntuación total será el ganador</h3>
				<p>
					En caso de empate, ganará el equipo que haya resuelto el caso en menos
					tiempo hasta la última pantalla.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Atención</h3>
				<p>
					No está permitido manipular material que no esté identificado como
					parte del juego.
				</p>
			</div>
			<div className="start-game-rule-block start-game-rule-block--emphasis">
				<h3>Recuerden</h3>
				<p>
					Lo importante no es solo ganar, sino aprender y aplicar la evidencia
					científica en la práctica clínica.
				</p>
			</div>
		</StartGameFlowLayout>
	);
}
